import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import Modal from '../UI/Modal';

const DeleteReport = ({ closeDeleteModal, showDelete, deleteMessage }) => {
    const [show, setShow] = useState(showDelete);
    const { handleSubmit } = useForm();

    const handleClose = () => {
        setShow(false);
        closeDeleteModal();
    }
    return (
        <>
            <Modal
                handleClose={handleClose}
                show={show}
                handleSubmit={handleSubmit}
                onSubmit={deleteMessage}
                buttonLabel="Delete"
            >
                <h5 className="mb-4">Are you sure you want to delete this item?</h5>
            </Modal>
        </>
    )
}

export default DeleteReport;
